import React from 'react';
import classNames from 'classnames';
import { useTranslation } from '../../i18n/LanguageProvider';
import { SUPPORTED_LANGUAGES } from '../../i18n/translations';

const LanguageSwitcher = ({ className }) => {
  const { language, setLanguage, t } = useTranslation();

  const toggleLanguage = () => {
    const currentIndex = SUPPORTED_LANGUAGES.indexOf(language);
    const nextLanguage = SUPPORTED_LANGUAGES[(currentIndex + 1) % SUPPORTED_LANGUAGES.length];
    setLanguage(nextLanguage);
  };

  return (
    <button
      type="button"
      className={classNames('button', 'button-sm', 'button-dark', 'button-wide-mobile', className)}
      onClick={toggleLanguage}
      aria-label={t('common.languageToggle', { language: language === 'pt' ? 'EN' : 'PT' })}
    >
      {t('common.languageLabel')}: {language.toUpperCase()}
    </button>
  );
};

export default LanguageSwitcher;
